import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[(_vm.loading)?_c('loading'):_vm._e(),_c(VDivider),_c('br'),_c(VAlert,{attrs:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.response)+" ")]),_c(VDivider),_c('br'),_c(VAlert,{attrs:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]),_c(VDivider),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }